import {
  StatusColorMap,
  StatusLabelMap,
} from "../../../shared/components/chips/StatusChip";
import colors from "../../../shared/themes/colors";
import { OfferStatusCode } from "../models/models";
import { dt } from "../../../shared/themes/redesignTokens";

export const createOfferStatusLabelMap = (
  translate: (key: string) => string
): StatusLabelMap<OfferStatusCode> => ({
  [OfferStatusCode.draft]: translate("draft"),
  [OfferStatusCode.sent]: translate("sent"),
  [OfferStatusCode.viewed]: translate("viewed"),
  [OfferStatusCode.negotiating]: translate("negotiating"),
  [OfferStatusCode.accepted]: translate("accepted"),
  [OfferStatusCode.rejected]: translate("rejected"),
  [OfferStatusCode.expired]: translate("expired"),
  [OfferStatusCode.withdrawn]: translate("withdrawn"),
  [OfferStatusCode.awaitingConfirmation]: translate("awaitingConfirmation"),
  [OfferStatusCode.confirmed]: translate("confirmed"),
  [OfferStatusCode.workInProgress]: translate("workInProgress"),
  [OfferStatusCode.workCompleted]: translate("workCompleted"),
  [OfferStatusCode.serviceCompleted]: translate("serviceCompleted"),
  [OfferStatusCode.archived]: translate("archived"),
});

export const createOfferStatusColorMap = (): StatusColorMap<OfferStatusCode> => ({
  [OfferStatusCode.draft]: {
    backgroundColor: colors.backgrounds.violet,
    textColor: colors.icons.violet,
  },
  [OfferStatusCode.sent]: {
    backgroundColor: colors.primary.lightBlue3,
    textColor: dt.blue,
  },
  [OfferStatusCode.viewed]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.negotiating]: {
    backgroundColor: colors.backgrounds.orange,
    textColor: colors.icons.orange,
  },
  [OfferStatusCode.accepted]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green,
  },
  [OfferStatusCode.rejected]: {
    backgroundColor: colors.backgrounds.red,
    textColor: colors.icons.red,
  },
  [OfferStatusCode.expired]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.withdrawn]: {
    backgroundColor: colors.secondary.gray85,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.awaitingConfirmation]: {
    backgroundColor: "#FEF9E7",
    textColor: "#F39C12",
  },
  [OfferStatusCode.confirmed]: {
    backgroundColor: "#E8F8F5",
    textColor: "#1ABC9C",
  },
  [OfferStatusCode.workInProgress]: {
    backgroundColor: colors.primary.lightBlue3,
    textColor: dt.blue,
  },
  [OfferStatusCode.workCompleted]: {
    backgroundColor: "#FEF9E7",
    textColor: "#F39C12",
  },
  [OfferStatusCode.serviceCompleted]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green,
  },
  [OfferStatusCode.archived]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
});
